import ReactGA from 'react-ga4';
import { selectCloudInstance } from 'store/Config/selector';

const selectIsEnabled = (state) => selectCloudInstance(state);

export function initialize (key) {
  return async (_, getState) => {
    const isEnabled = selectIsEnabled(getState());
    if (isEnabled) {
      ReactGA.initialize(key || 'developGaKey');
    }
  };
}

export function trackPageView (url) {
  return async (_, getState) => {
    const isEnabled = selectIsEnabled(getState());
    if (isEnabled) ReactGA.send({ hitType: 'pageview', page: url });
  };
}

export function trackEvent (category, action, label, value) {
  return async (_, getState) => {
    const isEnabled = selectIsEnabled(getState());
    if (isEnabled) {
      ReactGA.event({
        category,
        action,
        label,
        value
      });
    }
  };
}
